import { Orbit, ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Source N Universe", href: "https://sourcenuniverse.com/", testid: "footer-link-sourcenuniverse" },
  { label: "YouTube", href: "https://youtube.com/@shifts_frequency?si=hjI8v_aHHtwATRFl", testid: "footer-link-youtube" },
  { label: "Discord", href: "https://discord.gg/uvMNCcCYkx", testid: "footer-link-discord" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-black/60 px-6 py-14 sm:px-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 text-center">
        <div>
          <div className="flex items-center justify-center gap-2.5">
            <Orbit className="h-5 w-5 text-cyan-300" strokeWidth={1.5} />
            <span className="font-display text-base font-bold tracking-[0.4em] text-slate-100" data-testid="footer-brand">
              THE SHIFT
            </span>
          </div>
          <p className="font-display mt-4 text-[10px] tracking-[0.35em] text-slate-500" data-testid="footer-tagline">
            AWAKENING • ENERGY • FREQUENCY • CONSCIOUSNESS
          </p>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4" data-testid="footer-links">
          {LINKS.map((l) => (
            <a
              key={l.label}
              data-testid={l.testid}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className="font-display text-[11px] tracking-[0.28em] text-slate-400 transition-colors duration-300 hover:text-cyan-300"
            >
              {l.label.toUpperCase()}
            </a>
          ))}
        </nav>

        <div className="flex w-full flex-col items-center gap-6 border-t border-white/5 pt-8 sm:flex-row sm:justify-between">
          <p className="font-display text-[10px] tracking-[0.25em] text-slate-600" data-testid="footer-copyright">
            © 2026 SOURCE N UNIVERSE
          </p>
          <button
            data-testid="footer-back-to-top-btn"
            onClick={() => scrollToId("#top")}
            className="flex items-center gap-2 font-display text-[10px] tracking-[0.3em] text-slate-500 transition-colors duration-300 hover:text-cyan-300"
            aria-label="Back to top"
          >
            RETURN TO THE PORTAL
            <ArrowUp className="h-3.5 w-3.5" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </footer>
  );
}
